import { useEffect } from "react";
import { useAddContactsBulkMutation } from "../../../../../features/contactsApi";
import { addBannerWithTimeout } from "../../../../lib/centralizedBanner/slice";
import { ContactType, FindAllContactsFilters } from "../../../../lib/filters/dto";
import { initialStateContactsFilters } from "../../../../lib/filters/filtersSlice";
import { useAppDispatch } from "../../../../lib/redux/hooks";
import { ConfirmModal } from "../../../../ui/organisms/confirmModal.tsx";
import { TargetListPageEnum } from "../../dto";
import { setTargetListPage } from "../../slice";

export function AddContactsFromDatabaseModal({ filters, setFilters, showModal, setShowModal, contactType, targetId }: { filters: FindAllContactsFilters, setFilters: (filters: FindAllContactsFilters) => void, showModal: boolean, setShowModal: (show: boolean) => void, contactType: ContactType, targetId: string }) {
    const dispatch = useAppDispatch();

    const [addContactsBulk, {
        isLoading: isAddingContactsBulk,
        reset: resetMutationBulk
    }] = useAddContactsBulkMutation();

    useEffect(() => {
        return () => {
            resetMutationBulk();
        };
    }, [resetMutationBulk,]);

    const handleCloseDeleteModal = () => {
        setShowModal(false);
        resetMutationBulk();
    }

    const handleDeletePeopleConfirm = async () => {
        try {
            await addContactsBulk({ filters, targetListId: targetId || "", contactType }).unwrap();
            setFilters({ ...initialStateContactsFilters['add-target-db'][contactType] });
            dispatch(setTargetListPage(TargetListPageEnum.LIST));
            handleCloseDeleteModal();
            dispatch(addBannerWithTimeout({
                message: "Contatti aggiunti con successo",
                variant: "success"
            }));

        } catch (error: any) {
            setFilters({ ...initialStateContactsFilters['add-target-db'][contactType] });
            handleCloseDeleteModal();
            dispatch(addBannerWithTimeout({
                message: "Si è verificato un errore durante l'aggiunta dei contatti",
                variant: "error"
            }));
        }
    };

    return (
        <ConfirmModal
            key={"add-bulk-contacts-modal"}
            loading={isAddingContactsBulk}
            title={"Importare tutti i contattisss?"}
            label={"Tutti i contatti corrispondenti ai filtri selezionati verranno aggiunti. Sei sicuro di voler procedere?"}
            confirmAction={handleDeletePeopleConfirm}
            onClose={handleCloseDeleteModal}
            visible={showModal}
        />
    )
}